export default {
  esg_dashboard: {
    title: '數據儀表板',
  },
  improvement_plans: {
    title: '改善計畫',
  },
  question_group_section: {
    card_title: '未回覆的調查表／問卷',
    list_header_buyer_company_name: '委託評估企業',
    list_header_question: '@:score_summary_section.list_header_question',
    list_header_deadline: '回答期限',
    list_header_status: '狀態',
    number_of_answered_label: '回答數',
    // number_of_answered_unit: '',
    number_of_answered: '進度： {answered}/{total}',
    status_re_answer_request: '委託撤銷中',
    answer: '回答',
    withdrawn: '已退回',
    // no_survey_response_requests_text_1:  '',
    // contact: '',
    // no_survey_response_requests_text_2: '',
  },
  score_summary_section: {
    card_title: '@:common.scorecard.title',
    list_header_buyer_company_name: '委託評估企業',
    list_header_question: '問卷',
    list_header_create_at: '發行日',
    list_header_deadline: '有效期限',
    list_header_status: '狀態',
    limit_one_year: '從發行日起1年內',
    esg_score: 'ESG評分',
    esg_rating: 'ESG評級',
    detail: '詳細內容',
  },
  faq_section: {
    card_title: '常見提問',
    faq_why_request: {
      question: '交易對象要求我提供ASUENE ESG的回答，為什麼會有這樣的要求呢？',
      answer:
        '近年，永續採購的措施受到關注，特別是以大企業為主，被要求於進行事業時需要考量ESG相關的社會需求，包含供應鏈的環境或人權。像這樣的措施，不僅只是大企業自身的措施，也需要掌握「自己公司的交易對象是否有實施ESG措施」。',
    },
    faq_what_benefit: {
      question: '提供ASUENE ESG的回答會有什麼好處呢？',
      answer:
        '接受ASUENE ESG，有以下3個好處。\n1)可掌握貴公司ESG相關的優勢與改善點\n2)貴公司的ESG評估可與同業其他公司進行比較\n3)透過對外公開ESG評估結果，可展現貴公司的ESG措施內容',
    },
    list: '瀏覽一覽表',
  },
  contact_section: {
    card_title: '聯絡我們',
    description:
      '對於問卷內容或回答方法有任何不清楚之處，請隨時聯絡我們。需要更為具體的ESG措施改善協助支援，也可另外由專門顧問提供支援。',
    inquiry: '聯絡我們',
  },
}
